import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';

import { ChangeEvent } from 'react';

import { ReactComponent as DeleteIcon } from 'common/assets/images/delete-icon.svg';
import { ReactComponent as Plus } from 'common/assets/images/Plus.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import TextFieldWithLabel from 'common/components/TextFieldWithLabel/TextFieldWithLabel';
import { toSentenceCase } from 'common/utils/utilFunctions';

import { IPromptLayout } from '../../api/type-def';

import { TYPE_OPTIONS } from '../PromptBuilderConstants';
import detailStyles from '../PromptBuilderDetails.module.scss';

import styles from './PromptLayout.module.scss';

const PromptLayout = (props: IPromptLayout) => {
	/* Destructured variables */
	const {
		onSystemMsgChangeHandler,
		onPromptChangeHandler,
		onUserChangeHandler,
		onAssistantChangeHandler,
		onAddBtnClickHandler,
		onPromptDeleteHandler,
		prompt,
		messages,
		systemText,
		isAddClicked,
	} = props;
	const { CHAT_COMPLETION } = TYPE_OPTIONS;
	const { addNewButtonColor, deleteIconFillColor, paddingY, paddingX } = styles;

	const clickIndicator = messages.length > 0 || isAddClicked;

	/* Local variables */
	const textFieldStyles = {
		'& .MuiInputBase-root.MuiFilledInput-root': {
			padding: `${paddingY} ${paddingY} ${paddingX}`,
		},
	};

	return (
		<Grid container>
			<Grid item xs={12}>
				<Typography className={styles['sub-header']}>
					{toSentenceCase('Prompt')}
					<span className={detailStyles.mandatory}>*</span>
				</Typography>
				<TextFieldWithLabel
					inputProps={{
						'data-testid': 'prompt-text',
					}}
					error={false}
					value={prompt?.prompt}
					onChange={(e: ChangeEvent<HTMLInputElement>) =>
						onPromptChangeHandler('prompt', e)
					}
					helperText=""
					showLabel
					fullWidth
					multiLine
					className={styles['prompt-text']}
					readOnly={!prompt?.is_draft}
				/>
			</Grid>
			{prompt?.type?.toLowerCase() === CHAT_COMPLETION.toLowerCase() && (
				<Grid item xs={12}>
					<Typography className={styles['sub-header-text']}>
						{toSentenceCase('System message')}
						<span className={detailStyles.mandatory}>*</span>
					</Typography>
					<div>
						<TextFieldWithLabel
							inputProps={{
								'data-testid': 'prompt-system-msg',
							}}
							error={false}
							value={systemText}
							onChange={onSystemMsgChangeHandler}
							helperText=""
							showLabel
							required
							fullWidth
							multiLine
							className={styles['system-prompt-text']}
							readOnly={!prompt?.is_draft}
						/>
						{clickIndicator && (
							<div>
								{messages?.map((message) => (
									<div key={message?.id}>
										<Stack className={styles['user-msg-header']}>
											<Typography className={styles['sub-header-text']}>
												{toSentenceCase('User')}
											</Typography>
											<IconButton
												className={styles['delete-icon-wrapper']}
												data-testid="delete-action"
												onClick={() => onPromptDeleteHandler(message)}
												disabled={!prompt?.is_draft}
											>
												<DeleteIcon
													data-testid="delete-icon"
													className={styles['status-delete-stack']}
													fill={deleteIconFillColor}
												/>
											</IconButton>
										</Stack>
										<TextFieldWithLabel
											inputProps={{
												'data-testid': 'user-msg',
											}}
											error={false}
											value={message?.user}
											onChange={(event: ChangeEvent<HTMLInputElement>) =>
												onUserChangeHandler(message?.id, event)
											}
											helperText=""
											showLabel
											fullWidth
											multiline
											rows={4}
											className={styles['text-field-small']}
											sx={textFieldStyles}
											readOnly={!prompt?.is_draft}
										/>
										<Typography className={styles['sub-header-text']}>
											{toSentenceCase('Assistant')}
										</Typography>
										<TextFieldWithLabel
											inputProps={{
												'data-testid': 'assistant-msg',
											}}
											error={false}
											value={message?.assistant}
											onChange={(event: ChangeEvent<HTMLInputElement>) =>
												onAssistantChangeHandler(message?.id, event)
											}
											helperText=""
											showLabel
											fullWidth
											multiline
											rows={4}
											className={styles['text-field-small']}
											sx={textFieldStyles}
											readOnly={!prompt?.is_draft}
										/>
									</div>
								))}
							</div>
						)}
						<ButtonComp
							btnType="secondary"
							clickHandler={onAddBtnClickHandler}
							data-testid="add-example-btn"
							disabled={!prompt?.is_draft}
						>
							<Box className={styles['btn-component-box']}>
								<div className={styles['plus-icon']}>
									<Plus fill={addNewButtonColor} />
								</div>
								<Typography>{toSentenceCase('Add an example')}</Typography>
							</Box>
						</ButtonComp>
					</div>
				</Grid>
			)}
		</Grid>
	);
};

export default PromptLayout;
